"use client";
import Image from "next/image";
import Link from "next/link";

const Hero = ({ title, image, breadcrumbs }) => {
  return (
    <div>
      <section className=" py-5 md:py-9 lg:py-9  z-20">
        {/* Content */}
        <div className="relative z-20 max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 gap-3 items-center justify-between text-gray-300">
            <div>
              {/* Title */}
              <h1 className="text-black text-center text-4xl my-3">{title}</h1>

              {/* Breadcrumbs */}
              <p className="text-center">
                {breadcrumbs.map((breadcrumb, index) => (
                  <span key={index}>
                    <Link href={breadcrumb.href} className="text-black ">
                      {breadcrumb.label}
                    </Link>
                    {index < breadcrumbs.length - 1 && " / "}
                  </span>
                ))}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
